import cx from 'classnames'
import { Tooltip } from 'antd'
import LogoIcon from '../../assets/compact-logo.svg?react'
import CollapseIcon from '../../assets/icons/menu.svg?react'

type LogoProps = {
  collapsed?: boolean
  className?: string
  onToggle?: () => void
}

export default function Logo({ collapsed = false, className, onToggle }: LogoProps): JSX.Element {
  return (
    <div
      className={cx(
        'flex items-center justify-center transition-all duration-300 w-full',
        className
      )}
    >
      <div
        className={cx(
          'flex items-center gap-2 overflow-hidden transition-all duration-300 ease-in-out',
          collapsed ? 'opacity-0 max-w-0' : 'opacity-100 max-w-full'
        )}
      >
        <LogoIcon className='w-8 h-8 shrink-0' />
        <div className='flex flex-col leading-tight w-[160px]'>
          <span
            className='text-[22px] font-bold truncate whitespace-nowrap'
            style={{ color: '#005F7F' }}
          >
            Lucent Health
          </span>
          <span className='text-[8px] truncate whitespace-nowrap font-semibold leading-none'>
            <span style={{ color: '#005F7F' }}>DATA DRIVEN</span>
            <span style={{ color: '#97D8EA' }} className='px-1 font-normal'>
              +
            </span>
            <span style={{ color: '#005F7F' }}>HUMAN FOCUSED</span>
          </span>
        </div>
      </div>
      {onToggle && (
        <Tooltip title={collapsed ? 'Expand navigation' : 'Collapse navigation'} placement='right'>
          <button
            onClick={onToggle}
            className={cx(
              'ml-auto size-8 rounded-md transition-colors flex items-center justify-center shrink-0',
              'bg-transparent hover:bg-zinc-100',
              'text-zinc-700 hover:text-zinc-800'
            )}
            aria-label={collapsed ? 'Expand navigation' : 'Collapse navigation'}
          >
            <span className='flex items-center justify-center w-6 h-6'>
              <CollapseIcon
                className={cx(
                  'w-4 h-4 block transition-transform duration-200',
                  collapsed && 'scale-x-[-1]'
                )}
              />
            </span>
          </button>
        </Tooltip>
      )}
    </div>
  )
}
